import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getSavedFilters = async () => {
  return await request.get(
    `/Filter`,
    { type: 'DOCS' },
    'При загрузке сохраненных фильтров произошла ошибка'
  );
};

const useSavedFiltersQuery = (options) =>
  useQuery(queryKeys.savedFilters(), getSavedFilters, options);

export default useSavedFiltersQuery;
